import NotificationInfo from "./NotificationInfo";
import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { makeAjax, url, showMessage, respStatus } from "../../../helpers/global_helper";
import InfiniteScroll from "react-infinite-scroll-component";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { getUserBalance } from '../../../redux/actions';

const NotificationPopup = (props) => {
  const dispatch = useDispatch();
  const { onClose } = props;
  const [notificationCount, setNotificationCount] = useState();
  const [isResultPopup, setIsResultPopup] = useState(false);
  const [notificationId, setNotificationId] = useState(null);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [notificationDetail, setNotificationDetail] = useState({});
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [openedNotificationIds, setOpenedNotificationIds] = useState([]); // NEW

  const openNotificationResultPopup = (notificationId) => {
    setNotificationId(notificationId);
    setIsResultPopup(true);
  };

  const openNotificationInfo = (notification) => {
    setNotificationDetail(notification);
    setSelectedNotification(true);

    // Mark notification as opened
    setOpenedNotificationIds((prev) =>
      prev.includes(notification.id) ? prev : [...prev, notification.id]
    );
  };

  const closeNotificationResultPopup = () => {
    setIsResultPopup(false);
    setSelectedNotification(false);
  };

  const fetchNotificationData = () => {
    let reqData = {
      page: page,
    };
    makeAjax(url.PLAYER_API.listNotification, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage("server error No data find", "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      const newData = response.data.notifResults.data; // Assuming your API returns an array of items
      setItems((prevItems) => [...prevItems, ...newData]);
      setPage((prevPage) => prevPage + 1);
      setHasMore(newData.length > 0);
      setNotificationCount(response.data.countNotif);
      dispatch(getUserBalance());
    });
  };

  useEffect(() => {
    fetchNotificationData();
  }, []);

  return (
    <div className="overlay">
      <div className="overlay_innerDiv" onClick={onClose}></div>
      <div className="notification_popup">
        <button className="notification_popup-close" onClick={onClose}>
          <IoMdClose className="btnclose" />
        </button>
        <div className="result_txt">{props.t('notification')}</div>
        <div className="notification_tble_result">
          <InfiniteScroll
            dataLength={items.length}
            next={() => fetchNotificationData()}
            pullDownToRefreshThreshold={60}
            hasMore={hasMore}
            // loader={<h4 className="ladtext">Loading...</h4>}
            endMessage={<p>{props.t("data_not_found")}</p>}
            scrollThreshold={0.7}
            height={"99vh"}
          >
            <table className="table_data" width="100%">
              <thead>
                <tr>
                  <th>{props.t("no.")}</th>
                  <th>{props.t("subject")}</th>
                  <th>{props.t("date")}</th>
                </tr>
              </thead>
              <tbody>
                {items &&
                  items.map((notification, index) => {
                    const date = new Date(notification.date);
                    const formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

                    const isNew =
                      notificationCount > 0 &&
                      index < notificationCount &&
                      !openedNotificationIds.includes(notification.id);

                    const isOpenedNotification = openedNotificationIds.includes(notification.id);

                    return (
                      <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                        <td>{index + 1}</td>
                        <td>
                          <div
                            className="notification_row_content"
                            onClick={() => openNotificationInfo(notification)}
                          >
                            <div className="notification_row_content">
                              <a
                                onClick={() => openNotificationResultPopup(notification.id)}
                                className={`notification-link${notification.isNew && !isOpenedNotification ? ' new' : ''}`}
                              >
                                {notification.subject}
                              </a>

                              <div className={`notification-link${notification.isNew && !isOpenedNotification ? ' new' : 'notification-link'}`}>
                                {isNew && !isOpenedNotification ? "New" : ""}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>{formattedDate}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>

        {selectedNotification && (
          <NotificationInfo
            notification={notificationDetail}
            onClose={closeNotificationResultPopup}
          />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(NotificationPopup);
